import React from "react";
import ProductStockService from "services/product-stock";

import { connect } from "react-redux";
import { loadStock } from "reducers/product";

class Product extends React.Component {
  productStockService = new ProductStockService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.productStockService
      .getAll()
      .then(({ data }) => this.props.loadStock(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { loadStock })(Product);
